import Vue from 'vue'
import Router from 'vue-router'
import NotFoundView from './components/404.vue'
import QuizzView from './components/Quizz.vue'
import NoQuizzView from './components/NoQuizz.vue'
import ShopView from './components/Shop.vue'
import HomeView from './components/Home.vue'
import TermsView from './components/Terms.vue'
import PrivacyView from './components/Privacy.vue'
import FAQView from './components/FAQ.vue'
Vue.use(Router)

// Routes
const routes = [
  {
    path: '/',
    name: 'App',
    component: HomeView
  }, {
    path: '/quizz/:id',
    component: QuizzView
  }, {
    path: '/terms',
    component: TermsView
  }, {
    path: '/privacy',
    component: PrivacyView
  }, {
    path: '/quizz',
    component: NoQuizzView
  }, {
    path: '/faq',
    component: FAQView
  }, {
    path: '/shop',
    component: ShopView
  }, {
    // not found handler
    path: '*',
    component: NotFoundView
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js